import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private translations: Record<string, Record<string, unknown>> = {};
  private loadedLangs = new Set<string>();

  constructor(
    private http: HttpClient,
    private language: LanguageService
  ) {
    this.language.currentLang$.subscribe(lang => this.loadLang(lang).subscribe());
  }

  instant(key: string, params?: Record<string, string | number>): string {
    const lang = this.language.currentLang;
    const dict = this.translations[lang];
    if (!dict) return key;
    const keys = key.split('.');
    let value: unknown = dict;
    for (const k of keys) {
      value = (value as Record<string, unknown>)?.[k];
      if (value == null) return key;
    }
    let text = typeof value === 'string' ? value : key;
    if (params && text !== key) {
      for (const [paramKey, paramVal] of Object.entries(params)) {
        text = text.split(`{${paramKey}}`).join(String(paramVal));
      }
    }
    return text;
  }

  get(key: string): Observable<string> {
    return this.language.currentLang$.pipe(
      map(() => this.instant(key))
    );
  }

  loadLang(lang: string): Observable<Record<string, unknown>> {
    if (this.loadedLangs.has(lang)) {
      return of(this.translations[lang] || {});
    }
    return this.http.get<Record<string, unknown>>(`/assets/i18n/${lang}.json`).pipe(
      map(data => {
        this.translations[lang] = data;
        this.loadedLangs.add(lang);
        return data;
      })
    );
  }
}
